import { Link } from "react-router-dom";
import { withLayout } from "../../components/feature/PageLayout";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

const timelineItems = [
  {
    phase: "起點｜身心壓力 → 遇見精油",
    desc: "我的故事，始於一瓶小小的精油。那股香氣，讓我第一次感受到被陪伴與被照顧的力量，也開啟了我人生全新的篇章。",
  },
  {
    phase: "過程｜學習芳香療癒 ＋ 團隊經營",
    desc: "從療癒自己開始，我一步步走上創業之路；我不只是精油的愛用者，更投入系統化學習，整合芳療、生活應用與事業經營。",
  },
  {
    phase: "轉折｜創建「芳香創富系統」",
    desc: "我把所學整理為「心態調頻 → 精油應用 → 分享話術 → 團隊複製」四步驟，協助夥伴在 90 天內建立行動節奏，學會分享、成交與帶人。",
  },
  {
    phase: "成就｜引領 6000+ 家庭愛上精油 × 100+ 場培訓 × 女性創業顧問",
    desc: "多年來，我見證無數蛻變：從家庭主婦到自信講師、從小資族到創業領袖。真正讓我驕傲的，是團隊一次次的突破與成長。",
  },
];

const milestones = [
  { number: "6000+", label: "家庭" },
  { number: "100+", label: "場培訓 / 分享會" },
  { number: "90 天", label: "新手啟動里程碑" },
];

const galleryImages = [
  {
    title: "專業形象｜溫柔而堅定的引導者",
    description:
      "以柔和金色光感呈現品牌主理人的專業、自信與親和力，傳遞值得信任的芳香創富導師形象。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20professional%20woman%20in%20a%20cream%20silk%20blouse%2C%20warm%20golden%20lighting%2C%20soft%20natural%20portrait%20with%20gentle%20smile%2C%20feminine%20confidence%2C%20minimal%20beige%20background%2C%20luxurious%20editorial%20photography%20style%2C%20warm%20amber%20tones%2C%20professional%20yet%20approachable&width=600&height=500&seq=about-gallery-01&orientation=portrait",
  },
  {
    title: "團隊精神｜同行共好，彼此成就",
    description:
      "透過交流、陪伴與共同學習的畫面，展現團隊不是單打獨鬥，而是在支持中一起成長、一起綻放。",
    image:
      "https://readdy.ai/api/search-image?query=Group%20of%20women%20in%20a%20bright%20airy%20workshop%20space%2C%20all%20smiling%20and%20engaged%20in%20conversation%2C%20essential%20oil%20bottles%20on%20a%20wooden%20table%2C%20warm%20natural%20light%20streaming%20through%20windows%2C%20cream%20and%20beige%20interior%2C%20supportive%20community%20atmosphere%2C%20team%20spirit%20photography&width=600&height=500&seq=about-gallery-02&orientation=portrait",
  },
  {
    title: "日常療癒｜把香氣帶進生活日常",
    description:
      "從閱讀、擴香到靜心時刻，讓香氛成為生活中的溫柔儀式，陪伴自己回到平衡與安定。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20morning%20ritual%20scene%20with%20essential%20oil%20diffuser%2C%20a%20beautiful%20ceramic%20mug%20of%20tea%2C%20open%20journal%20with%20elegant%20handwriting%2C%20soft%20sunlight%20through%20sheer%20curtains%2C%20dried%20lavender%20bundle%2C%20cream%20and%20warm%20beige%20tones%2C%20peaceful%20feminine%20self%20care%20aesthetic&width=600&height=500&seq=about-gallery-03&orientation=portrait",
  },
  {
    title: "分享能量｜從被療癒，到照亮他人",
    description:
      "用分享與帶領，將香氣的美好傳遞出去，讓成長不只停留在自己，也能成為他人的力量。",
    image:
      "https://readdy.ai/api/search-image?query=Woman%20presenting%20to%20a%20small%20group%20in%20a%20warm%20lit%20room%2C%20gesturing%20confidently%2C%20essential%20oil%20display%20on%20a%20table%2C%20attentive%20audience%20of%20women%2C%20golden%20hour%20lighting%2C%20empowerment%20and%20education%20vibe%2C%20cream%20walls%20and%20warm%20atmosphere&width=600&height=500&seq=about-gallery-04&orientation=portrait",
  },
];

function About() {
  return (
    <>
      <SEOHead
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "香氛女王",
          "jobTitle": "芳香創富導師｜身心靈財富整合女王",
          "description": "結合芳香療癒與創富系統的導師，帶領 6000+ 家庭透過精油與系統陪跑。",
          "url": `${siteUrl}/about`,
          "image": "https://readdy.ai/api/search-image?query=Elegant%20professional%20woman%20in%20a%20cream%20silk%20blouse%2C%20warm%20golden%20lighting%2C%20soft%20natural%20portrait%20with%20gentle%20smile%2C%20feminine%20confidence%2C%20minimal%20beige%20background%2C%20luxurious%20editorial%20photography%20style%2C%20warm%20amber%20tones%2C%20professional%20yet%20approachable&width=600&height=500&seq=about-gallery-01&orientation=portrait",
          "sameAs": [
            "https://line.me/R/ti/p/@your-id",
            "https://www.instagram.com/your-handle"
          ]
        }}
      />
      {/* Hero */}
      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20an%20elegant%20woman%20in%20a%20soft%20cream%20blouse%2C%20natural%20smile%2C%20surrounded%20by%20delicate%20white%20flowers%20and%20essential%20oil%20bottles%2C%20soft%20golden%20sunlight%20creating%20a%20warm%20glow%2C%20feminine%20luxurious%20aromatherapy%20aesthetic%2C%20cream%20and%20amber%20tones%2C%20editorial%20portrait%20photography%20with%20soft%20focus%20background&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
          alt="香氛女王 - 芳香療癒與創富導師"
          title="香氛女王的幸福大地 關於我"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <p className="text-[1rem] md:text-[1.125rem] text-white/75 mb-3">
            About Me
          </p>
          <h1 className="text-[2rem] md:text-[2.75rem] font-bold text-white leading-[1.3] mb-3 md:mb-4">
            我是香氛女王，一位結合芳香療癒與創富系統的導師
          </h1>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] max-w-[680px] mx-auto">
            從療癒自己，到引領超過 6000
            個家庭用天然的方式來守護健康。我的使命，是讓每個人都能透過精油，擁有更美好、豐盛、自由的人生。
          </p>
        </div>
      </section>

      {/* Quote */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <p className="text-[1.25rem] md:text-[1.5rem] italic text-secondary-500 font-medium leading-[1.6]">
            「香氣，是靈魂的語言，也是財富的頻率。」
          </p>
        </div>
      </section>

      {/* Story Timeline */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            <div className="lg:w-[45%]">
              <span className="inline-block text-[1rem] font-medium text-foreground-600 bg-background-200/70 rounded-full px-4 py-1.5 mb-4">
                從精油到自由的轉折點
              </span>
              <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-6">
                從精油到自由的轉折點
              </h2>
              <div className="space-y-5">
                {timelineItems.map((item, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="flex-shrink-0 w-2.5 h-2.5 mt-2 rounded-full bg-primary-500"></div>
                    <div>
                      <h3 className="text-[1.0625rem] font-semibold text-foreground-950 leading-[1.5] mb-1">
                        {item.phase}
                      </h3>
                      <p className="text-[1.1875rem] text-foreground-600 leading-[1.75]">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:w-[55%]">
              <div className="bg-secondary-500 rounded-[18px] p-6 md:p-8 h-full flex flex-col justify-center">
                <p className="text-[1.25rem] md:text-[1.5rem] italic text-white/90 leading-[1.6] mb-5">
                  「香氣，是靈魂的語言，也是財富的頻率。」
                </p>
                <p className="text-[1rem] text-white/70">— 香氛女王</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Milestones */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
            {milestones.map((item) => (
              <div
                key={item.label}
                className="bg-white rounded-[18px] p-6 md:p-8 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)]"
              >
                <p className="text-[2.5rem] md:text-[3rem] font-bold text-primary-500 leading-[1.2] mb-2">
                  {item.number}
                </p>
                <p className="text-[1.1875rem] text-foreground-600 leading-[1.6]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          {/* Section Header */}
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-4">
              品牌形象與生活片刻
            </h2>
            <p className="text-[1.125rem] md:text-[1.25rem] text-foreground-600 leading-[1.75] max-w-[780px] mx-auto mb-4">
              從專業形象、團隊互動到日常香氛儀式，這些畫面不只是生活紀錄，更是「香氛女王的幸福大地」所傳遞的陪伴、療癒、成長與分享。
            </p>

          </div>

          {/* Image Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
            {galleryImages.map((item) => (
              <div
                key={item.title}
                className="rounded-[18px] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.06)] bg-white"
              >
                <div className="w-full h-[240px] md:h-[260px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-[1.0625rem] font-semibold text-foreground-950 leading-[1.5] mb-2">
                    {item.title}
                  </h3>
                  <p className="text-[1rem] text-foreground-600 leading-[1.7]">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Closing Summary */}
          <div className="mt-10 md:mt-14 text-center">
            <p className="text-[1.125rem] md:text-[1.25rem] text-foreground-600 leading-[1.75] max-w-[720px] mx-auto italic">
              每一張照片，都是品牌精神的延伸；每一個片刻，都在說明：香氣不只是陪伴自己，也能成為成長、分享與創造幸福的起點。
            </p>
          </div>
        </div>
      </section>

      {/* Quote CTA */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
            <div className="lg:w-[40%]">
              <div className="rounded-[18px] overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.08)]">
                <div className="w-full h-[350px] md:h-[420px] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20a%20flowing%20cream%20dress%2C%20standing%20by%20a%20large%20window%20with%20warm%20golden%20sunlight%2C%20holding%20a%20small%20essential%20oil%20bottle%2C%20soft%20natural%20smile%2C%20luxurious%20minimal%20interior%20with%20dried%20flowers%2C%20feminine%20empowerment%20portrait%2C%20cream%20and%20amber%20tones%2C%20editorial%20photography&width=700&height=900&seq=about-quote-img&orientation=portrait"
                    alt="香氛女王形象照"
                    title="香氛女王 溫暖光線 自然微笑"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
            <div className="lg:w-[60%]">
              <p className="text-[1.25rem] md:text-[1.375rem] text-foreground-950 leading-[1.7] mb-4 italic">
                「讓香氣，帶你遇見更好的自己與人生」—— 這不只是我的標語，而是我與團隊正在共同實現的旅程。妳也想成為下一個透過香氣翻轉人生的人嗎？
              </p>
              <p className="text-[1rem] text-foreground-600 mb-6">
                — 香氛女王
              </p>
              <h3 className="text-[1.1875rem] text-foreground-950 leading-[1.75] mb-5">
                想認識我的系統與團隊文化？加入 LINE
                官方社群，或預約一對一諮詢。
              </h3>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://line.me/R/ti/p/@your-id"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
                >
                  加入 LINE@
                </a>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-colors duration-200"
                >
                  預約免費諮詢
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withLayout(About);